import { cn } from '../utils/cn';

const BTN =
  'bg-panel-2 border border-line text-text text-[17px] rounded-[4px] flex items-center justify-center transition-all duration-fast ease-snap hover:bg-panel-3 hover:border-line-strong disabled:opacity-40 disabled:cursor-not-allowed';

export function DPad({
  disabled = false,
  isNudgeDisabled,
  onNudge,
  centerLabel = 'NUDGE',
}: {
  disabled?: boolean;
  isNudgeDisabled?: (dx: -1 | 0 | 1, dy: -1 | 0 | 1) => boolean;
  onNudge?: (dx: -1 | 0 | 1, dy: -1 | 0 | 1) => void;
  centerLabel?: string;
}) {
  const btn = (dx: -1 | 0 | 1, dy: -1 | 0 | 1, glyph: string, cls: string) => {
    const buttonDisabled = disabled || isNudgeDisabled?.(dx, dy) === true;
    return (
      <button
        type="button"
        className={cn(BTN, cls)}
        disabled={buttonDisabled}
        onClick={() => onNudge?.(dx, dy)}
        aria-label={`Nudge ${glyph}`}
      >
        {glyph}
      </button>
    );
  };
  return (
    <div className="grid grid-cols-[repeat(3,36px)] grid-rows-[repeat(3,36px)] gap-[2px]">
      {btn(0, -1, '↑', 'col-start-2 row-start-1')}
      {btn(-1, 0, '←', 'col-start-1 row-start-2')}
      <div className="col-start-2 row-start-2 flex items-center justify-center font-mono text-[11px] text-text-dimmer">
        {centerLabel}
      </div>
      {btn(1, 0, '→', 'col-start-3 row-start-2')}
      {btn(0, 1, '↓', 'col-start-2 row-start-3')}
    </div>
  );
}
